
import JoinPriceServiceTableAppService from "@/apis.machine/JoinPriceServiceTableAppService";
import PriceTableAppService from "@/apis.machine/PriceTableAppService";
import { EnumUiDragType } from "@/models.machine/EnumUiDragType";
import UiSelectOption from "@/models.machine/UiSelectOption";
import MiezzButton from "@/models/MiezzButton";
import MiezzModal, { MiezzModalType } from "@/models/MiezzModal";
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import PriceServiceTableForm from "./PriceServiceTableForm.vue";
import PriceServiceTableSearchForm from "./PriceServiceTableSearchForm.vue";
import vuedraggable from "vuedraggable";
import { EnumPriceAmountType } from "@/models.machine/EnumPriceAmountType";
import MiezzPageList from "@/models/MiezzPageList";
import CompanyAppService from "@/apis.machine/CompanyAppService";
import { EnumCompanyType } from "@/models.machine/EnumCompanyType";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumSupplierSourceOption } from "@/models.machine/EnumSupplierSource";
import DtoFormPriceExport from "@/models.machine/DtoFormPriceExport";
import { ElMessage, ElMessageBox } from "element-plus";
import PriceAppService from "@/apis.machine/PriceAppService";
import DtoListItemPriceServiceShareSearch, {
  DtoListItemPriceServiceShareSearchMiezzListItems,
} from "@/models.machine/DtoListItemPriceServiceShareSearch";
import PriceServiceShareSearchAppService from "@/apis.machine/PriceServiceShareSearchAppService";
import MiezzForm from "@/models/MiezzForm";
import DtoFormPriceServiceShareSearch, {
  DtoFormPriceServiceShareSearchMiezzFormItems,
  DtoFormPriceServiceShareSearchRules,
} from "@/models.machine/DtoFormPriceServiceShareSearch";
import DtoFormPriceServiceShareSearch_PriceServiceShareSearchRelation from "@/models.machine/DtoFormPriceServiceShareSearch_PriceServiceShareSearchRelation";
import JoinPriceServiceTableSearchAppService from "@/apis.machine/JoinPriceServiceTableSearchAppService";
import DtoFormJoinPriceServiceTable_JoinPriceServiceTableSearch from "@/models.machine/DtoFormJoinPriceServiceTable_JoinPriceServiceTableSearch";
import DtoFormJoinPriceServiceTable from "@/models.machine/DtoFormJoinPriceServiceTable";
import { Row } from "element-plus/es/components/table-v2/src/components";
@Options({
  components: {
    PriceServiceTableForm,
    PriceServiceTableSearchForm,
    vuedraggable,
  },
})
export default class PriceTableCatalogue extends Vue {
  @Prop() serviceId?: string;
  @Prop() amountType?: EnumPriceAmountType;
  options: UiSelectOption<string>[] = [];
  active?: string = "";
  addBtn: MiezzButton = {
    Code: "add",
    Icon: "plus",
    Label: "基础价格表",
    Type: "text",
    Size: "small",
    PowerCode: "PriceManagement_Service_Detail_CostComposition_AddEdit",
  };
  addShareSearch: MiezzButton = {
    Code: "list-share-search",
    Icon: "plus",
    Label: "共享条件",
    Type: "text",
    Size: "small",
    PowerCode:
      "PriceManagement_Service_Detail_CostComposition_ShareSearch",
  };
  modal = new MiezzModal();
  modalSetting = new MiezzModal();
  modalId?: string;
  buttons: MiezzButton[] = [];
  modalSupplier = new MiezzModal(MiezzModalType.Dialog);
  listSupplier = new MiezzPageList<any, any, string>();

  modalShareSearch = new MiezzModal();
  listShareSearch = new MiezzPageList<
    any,
    DtoListItemPriceServiceShareSearch,
    string
  >();
  modalFormShareSearch = new MiezzModal();
  formShareSearch = new MiezzForm<DtoFormPriceServiceShareSearch, string>();
  handleAddShareSearchRelation: MiezzButton = {
    Code: "add-share-search-relation",
    Icon: "plus",
    Label: "添加",
    Type: "text",
    Size: "small",
  };

  created(): void {
    if (this.serviceId) {
      this.buttons = [
        {
          Code: "setting",
          Icon: "setting",
          Title: "设置",
          Type: "default",
          Size: "small",
          PowerCode:
            "PriceManagement_Service_Detail_CostComposition_AddEdit",
        },
        {
          Code: "edit",
          Icon: "edit",
          Title: "编辑",
          Type: "default",
          Size: "small",
          PowerCode:
            "PriceManagement_Service_Detail_CostComposition_AddEdit",
        },
        {
          Code: "delete",
          Icon: "delete",
          Title: "删除",
          Type: "default",
          Size: "small",
          Message: "是否确认删除",
          PowerCode:
            "PriceManagement_Service_Detail_CostComposition_Delete",
        },
        {
          Code: "drag-sort",
          Title: "拖曳",
          Icon: "Rank",
          Type: "default",
          Size: "small",
          PowerCode:
            "PriceManagement_Service_Detail_CostComposition_AddEdit",
        },
      ];

      this.modalShareSearch.Title = "共享条件列表";
      this.modalShareSearch.Width = "1200px";
      this.modalShareSearch.HandleClick = this.handleClick;
      this.modalShareSearch.Buttons = [
        {
          Code: "add-share-search",
          Label: "添加",
          Type: "primary",
          Size: "small",
        },
      ];

      this.listShareSearch.Fix = false;
      this.listShareSearch.HideCard = true;
      this.listShareSearch.EnabledDynamicSearch = false;
      this.listShareSearch.EnabledRadioSearch = false;
      this.listShareSearch.EnabledPagination = false;
      this.listShareSearch.Items =
        DtoListItemPriceServiceShareSearchMiezzListItems;
      this.listShareSearch.HandleFormat = (item, row) => {
        return item.Prop == "Relations"
          ? row.Relations?.map(
              (it) => `【${it.ServiceTableLabel}/${it.SearchLabel}】`
            ).join("")
          : undefined;
      };
      this.listShareSearch.RowButtons = [
        {
          Code: "edit-share-search",
          Title: "编辑",
          Icon: "edit",
          Type: "default",
          Size: "small",
        },
        {
          Code: "delete-share-search",
          Title: "删除",
          Icon: "delete",
          Type: "default",
          Message: "是否确认删除",
          Size: "small",
        },
      ];
      this.listShareSearch.Data = {
        Items: [],
      };

      this.modalFormShareSearch.Width = "800px";
      this.modalFormShareSearch.HandleClick = this.handleClick;
      this.modalFormShareSearch.Buttons = [
        {
          Code: "save-share-search",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];

      this.formShareSearch.Data = new DtoFormPriceServiceShareSearch();
      this.formShareSearch.Items = DtoFormPriceServiceShareSearchMiezzFormItems;
      this.formShareSearch.Rules = {};
      this.formShareSearch.Rules.Name = [
        {
          required: true,
          message: "信息不能为空",
          trigger: "blur",
        },
        {
          max: 256,
          message: "文本长度不能超过 256 个字符",
          trigger: "blur",
        },
      ];
      this.formShareSearch.Rules.ServiceTableId = [
        {
          required: true,
          message: "信息不能为空",
          trigger: "change",
        },
      ];
      this.formShareSearch.Rules.SearchId = [
        {
          validator: (rule: any, value: string, callback: any) => {
            if (!value) {
              return callback(new Error("信息不能为空"));
            } else if (
              (this.formShareSearch.Data.Relations?.filter((it) => it.FieldCode)
                .map((it) => it.FieldCode)
                .distinct().length ?? 0) > 1
            ) {
              return callback(new Error("要素需要一致"));
            } else if (
              (this.formShareSearch.Data.Relations?.filter(
                (it) => it.SearchId == value
              )?.map((it) => it.ServiceTableId).length ?? 0) > 1
            ) {
              return callback(new Error("重复信息，请重新添加"));
            }
            console.log(this.formShareSearch.Data.Relations, value);
            callback();
          },
          trigger: "change",
        },
      ];
    }
    if (this.amountType == EnumPriceAmountType.Cost) {
      this.buttons = [
        {
          Code: "supplier",
          Icon: "plus",
          Label: "供应商",
          Type: "text",
          Size: "small",
          PowerCode: "PriceManagement_Cost_RelationSupplier",
        },
        {
          Code: "export-all",
          Icon: "bottom",
          Label: "导出",
          Type: "text",
          Size: "small",
          PowerCode: "PriceManagement_Cost_Export",
        },
      ];
      this.modalSupplier.Title = "添加";
      this.modalSupplier.Description =
        "提示：可使用Ctrl+F调用浏览器自带查找工具，录入关键词搜索";
      this.modalSupplier.Width = "800px";
      this.modalSupplier.HandleClick = this.handleClick;
      this.modalSupplier.Buttons = [
        {
          Code: "save-supplier",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];

      this.listSupplier.Fix = false;
      this.listSupplier.HideCard = true;
      this.listSupplier.EnabledDynamicSearch = false;
      this.listSupplier.EnabledRadioSearch = false;
      this.listSupplier.EnabledPagination = false;
      this.listSupplier.Items = [
        {
          Prop: "NameZh",
          Label: "供应商中文名称",
        },
        {
          Prop: "NameEn",
          Label: "供应商英文名称",
        },
        {
          Prop: "SupplierSource",
          Label: "类别",
          Pipe: EnumPipe.Enum,
          Options: EnumSupplierSourceOption,
        },
      ];
      this.listSupplier.Data = {
        Items: [],
      };
    }
    this.handleGet();
  }

  handleShareSearchRowButtonClick(
    btn: MiezzButton,
    row: DtoListItemPriceServiceShareSearch,
    complete: () => void
  ): void {
    switch (btn.Code) {
      case "edit-share-search":
        this.modalFormShareSearch.Title = "编辑共享条件";
        PriceServiceShareSearchAppService.GetById(row.Id).then((r) => {
          this.formShareSearch.Data =
            r.data.Data ?? new DtoFormPriceServiceShareSearch();
          for (const item of this.formShareSearch.Data.Relations ?? []) {
            this.handleServiceTableIdChange(item);
          }
          this.modalFormShareSearch.Show = true;
          complete();
        });
        break;
      case "delete-share-search":
        PriceServiceShareSearchAppService.Delete([row.Id ?? ""]).then((r) => {
          PriceServiceShareSearchAppService.Get({
            ServiceId: this.serviceId,
          }).then((r) => {
            this.listShareSearch.Data = r.data.Data;
            complete();
          });
          complete();
        });
        break;
      default:
        break;
    }
  }
  handleServiceTableIdChange(
    row: DtoFormPriceServiceShareSearch_PriceServiceShareSearchRelation
  ): void {
    const serviceTable = this.options.firstOrDefault(
      (it) => it.Value == row.ServiceTableId
    );
    if (row.ServiceTableId && serviceTable) {
      row.Searchs =
        serviceTable.Data.FromSearchs?.map((it: any) => {
          const option = new UiSelectOption<string>();
          option.Label = it.FromColumnLabel;
          option.Value = it.Id;
          option.Data = it.FromColumn.Field.Code;
          return option;
        }) ?? [];
      const search = row.Searchs.firstOrDefault(
        (it: any) => it.Value == row.SearchId
      );
      row.SearchId = search?.Value;
      row.FieldCode = search?.Data;
    } else {
      row.Searchs = [];
      row.SearchId = undefined;
      row.FieldCode = undefined;
    }
  }

  handleSearchIdChange(
    row: DtoFormPriceServiceShareSearch_PriceServiceShareSearchRelation
  ): void {
    const search = row.Searchs.firstOrDefault(
      (it: any) => it.Value == row.SearchId
    );
    row.SearchId = search?.Value;
    row.FieldCode = search?.Data;
  }

  handleDeleteShareSearchRelation(index: number): void {
    console.log(this.formShareSearch.Data.Relations?.length ?? 0);
    if ((this.formShareSearch.Data.Relations?.length ?? 0) > 2) {
      this.formShareSearch.Data.Relations?.splice(index, 1);
    } else {
      ElMessage.warning("至少保留两条");
    }
  }

  @Watch("serviceId")
  onServiceId(): void {
    this.handleGet();
  }

  handleGet(): void {
    if (this.serviceId) {
      JoinPriceServiceTableAppService.GetSelect({
        ServiceId: this.serviceId,
      }).then((r) => {
        this.options = r.data.Data ?? [];
        const serviceTableId = this.$route.query.ServiceTableId as
          | string
          | undefined;
        this.active =
          serviceTableId && this.options.any((it) => it.Value == serviceTableId)
            ? serviceTableId
            : this.options.firstOrDefault()?.Value;
        this.handleInit(this.options, this.active);
      });
    } else {
      PriceTableAppService.GetSelect({ AmountType: this.amountType }).then(
        (r) => {
          this.options = r.data.Data ?? [];
          const tableId = this.$route.query.TableId as string | undefined;
          this.active = tableId
            ? tableId
            : this.options.firstOrDefault()?.Value;
          this.handleInit(this.options, this.active);
        }
      );
    }
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "add":
        this.modalId = undefined;
        this.modal.Title = "添加基础价格表";
        this.modal.Show = true;
        complete();
        break;
      case "list-share-search":
        this.modalId = undefined;
        PriceServiceShareSearchAppService.Get({
          ServiceId: this.serviceId,
        }).then((r) => {
          this.listShareSearch.Data = r.data.Data;
          this.modalShareSearch.Show = true;
          complete();
        });
        break;
      case "add-share-search":
        this.modalFormShareSearch.Title = "添加共享条件";
        this.formShareSearch.Data = new DtoFormPriceServiceShareSearch();
        this.formShareSearch.Data.ServiceId = this.serviceId;
        this.formShareSearch.Data.Relations = [
          { Searchs: [] },
          { Searchs: [] },
        ];
        this.modalFormShareSearch.Show = true;
        complete();
        break;
      case "add-share-search-relation":
        this.formShareSearch.Data.Relations?.push({ Searchs: [] });
        complete();
        break;
      case "save-share-search":
        MiezzForm.submit(this.$refs, "ruleFormShareSearch", (v) => {
          if (v) {
            PriceServiceShareSearchAppService.Post(this.formShareSearch.Data)
              .then(() => {
                PriceServiceShareSearchAppService.Get({
                  ServiceId: this.serviceId,
                }).then((r) => {
                  this.listShareSearch.Data = r.data.Data;
                  this.modalFormShareSearch.Show = false;
                  complete();
                });
              })
              .catch(complete);
          } else complete();
        });
        break;
      case "save-supplier":
        PriceTableAppService.RelationSupplier({
          Id: this.modalId,
          SupplierIds: this.listSupplier.SelectIds,
        }).then(() => {
          this.handleGet();
          this.modalSupplier.Show = false;
          complete();
        });
        break;
      default:
        break;
    }
  }

  hnadleDrop(e: any): void {
    if (e.oldIndex != e.newIndex && this.options && this.options.length > 1) {
      const draggingIndex = e.newIndex;
      let dropIndex;
      let type: EnumUiDragType;
      if (draggingIndex == 0) {
        type = EnumUiDragType.Before;
        dropIndex = 1;
      } else {
        type = EnumUiDragType.After;
        dropIndex = draggingIndex - 1;
      }
      const dragging = this.options[draggingIndex];
      const drop = this.options[dropIndex];
      JoinPriceServiceTableAppService.DragSort({
        DraggingId: dragging.Value,
        DropId: drop.Value,
        DragType: type,
      }).then(() => {
        this.handleGet();
      });
    }
  }

  handleOptionClick(
    btn: MiezzButton,
    option: UiSelectOption<string>,
    complete: () => void
  ): void {
    switch (btn.Code) {
      case "setting":
        this.modalId = option.Value;
        this.modalSetting.Title = `设置基础费-${option.Label}`;
        this.modalSetting.Width = "500px";
        this.modalSetting.Show = true;
        complete();
        break;
      case "edit":
        this.modalId = option.Value;
        this.modal.Title = `编辑基础费-${option.Label}`;
        this.modal.Show = true;
        complete();
        break;
      case "delete":
        JoinPriceServiceTableAppService.Delete([option.Value as string])
          .then(() => {
            this.handleGet();
            complete();
          })
          .catch(complete);
        break;
      case "supplier":
        this.modalId = option.Value;
        CompanyAppService.GetSelect({
          CompanyType: EnumCompanyType.Supplier,
          AmountType: EnumPriceAmountType.Cost,
          PriceTableId: this.modalId,
        }).then((r) => {
          if (this.listSupplier.Data) {
            this.listSupplier.Data.Items = r.data.Data;
            this.listSupplier.DefaultSelectIds =
              this.listSupplier.Data.Items?.filter(
                (it) => it.PriceTableRelationId
              ).map((it) => it.Id as string) ?? [];
          }
          this.modalSupplier.Show = true;
        });
        complete();
        break;
      case "export-all":
        var dto: DtoFormPriceExport = {};
        dto.TableId = option.Value;
        dto.TableName = "价格表";
        dto.AmountType = this.amountType;
        dto.All = true;
        ElMessageBox.confirm(`价格信息包含公式，请选择导出方式`, "导出", {
          confirmButtonText: "导出公式",
          cancelButtonText: "导出数值",
          distinguishCancelAndClose: true,
          showClose: true,
          type: "warning",
        })
          .then(() => {
            dto.ShowAmount = false;
            this.handleSaveExport(dto, complete);
          })
          .catch((action: string) => {
            if (action == "cancel") {
              dto.ShowAmount = true;
              this.handleSaveExport(dto, complete);
            } else {
              complete();
            }
          });
        break;
      default:
        break;
    }
  }

  handleSaveExport(dto: DtoFormPriceExport, complete: () => void): void {
    const message = ElMessage.warning({
      message: "正在下载",
      duration: 999999999,
    });
    PriceAppService.Export(dto)
      .then((r) => {
        // window.open(process.env.VUE_APP_BASE_URL + r.data.Data, "_blank");
        localStorage.setItem("download", "1");
        message.close();
        complete();
      })
      .catch(complete);
  }

  handleBeforeChoose(
    options: UiSelectOption<string>[],
    active?: string,
    e?: any
  ): void {
    if (
      e.target.innerText != "供应商" &&
      e.target.innerText != "导出" &&
      (e.target.nodeName == "DIV" || e.target.nodeName == "SPAN")
    ) {
      this.handleChoose(options, active);
    }
  }

  @Emit()
  handleInit(options: UiSelectOption<string>[], active?: string): void {
    this.active = active;
  }
  @Emit()
  handleChoose(options: UiSelectOption<string>[], active?: string): void {
    this.active = active;
  }
}
